const TwoColumnRow = ({ data }) => {
  const backgroundClass = data.isAlternateBackground ? "bg-sidebar" : "";
  return (
    <div
      className={`${backgroundClass} grid grid-cols-2 items-center p-[0.75rem] rounded-[1rem]`}
    >
      {[data.field1, data.field2].map((field, i) => (
        <div key={i} className="space-y-1 capitalize">
          <p className="text-sm">
            {field.label}{" "}
            {field.required && <span className="text-destructive">*</span>}
          </p>
          <p className="text-sm font-semibold">{field.value}</p>
        </div>
      ))}
    </div>
  );
};
export default TwoColumnRow